import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { DropShadowFilter } from "pixi-filters";
import { Container, Text, TextStyle } from "pixi.js";
import { UnboardingType } from "../UnboardingType";

export class SecondPageHeaderTextContainer extends Container {
    public constructor(type: UnboardingType) {
        super();
        switch (type) {
            case UnboardingType.OWNER:
                this.buildOwnerText();
                break;
            case UnboardingType.RENTER:
                this.buildRenterText();
                break;
        }
    }

    private buildRenterText(): void {
        const headerText = new Text(`YOU'VE JUST SECURED\nYOUR FIRST PLACE\nFOR RENT!`, new ContainerTextStyle());
        headerText.style.lineHeight = 95.5;
        headerText.style.dropShadow = true;
        headerText.style.dropShadowAngle = 0;
        headerText.style.dropShadowBlur = 20;
        headerText.style.dropShadowColor = "#FF00B8";
        headerText.style.dropShadowDistance = -3;
        headerText.angle = -5;
        headerText.skew.x = -0.08;
        headerText.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0xffab5d })];
        this.addChild(headerText);
    }

    private buildOwnerText(): void {
        const expandText = new Text(`EXPAND YOUR BUILDING`, new ContainerTextStyle());
        expandText.style.fontSize = 44;
        expandText.style.dropShadow = true;
        expandText.style.dropShadowAngle = 0;
        expandText.style.dropShadowBlur = 20;
        expandText.style.dropShadowColor = "#FF00B8";
        expandText.style.dropShadowDistance = -3;
        expandText.angle = -5;
        expandText.skew.x = -0.08;
        expandText.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0xffab5d })];
        this.addChild(expandText);
        const portfolioText = new Text(`PORTFOLIO AND CONSTRUCT`, new ContainerTextStyle());
        portfolioText.style.fontSize = 64;
        portfolioText.style.dropShadow = true;
        portfolioText.style.dropShadowAngle = 0;
        portfolioText.style.dropShadowBlur = 20;
        portfolioText.style.dropShadowColor = "#FF00B8";
        portfolioText.style.dropShadowDistance = -3;
        portfolioText.angle = -5;
        portfolioText.skew.x = -0.08;
        portfolioText.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0xffab5d })];
        portfolioText.position.set(-103, 65);
        this.addChild(portfolioText);
        const empireText = new Text(`YOUR OWN EMPIRE`, new ContainerTextStyle());
        empireText.style.fontSize = 118;
        empireText.style.dropShadow = true;
        empireText.style.dropShadowAngle = 0;
        empireText.style.dropShadowBlur = 20;
        empireText.style.dropShadowColor = "#FF00B8";
        empireText.style.dropShadowDistance = -3;
        empireText.angle = -5;
        empireText.skew.x = -0.08;
        empireText.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0xffab5d })];
        empireText.position.set(-176, 143);
        this.addChild(empireText);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 107,
            fill: 'ffffff',
            align: "center"
        });
    }
}